export default class APIError {
	constructor(
		public readonly message: string,
		public readonly code: number
	) {}
}